import React from 'react';
import './Footer.css';

const Footer = ({ translatedText }) => (
	<div className="site-footer row">
		<div className="container">
			<p className="footer-text">
				&copy; {new Date().getFullYear()} Research Now Group, Inc. {translatedText.disclaimer[0]}&nbsp;
				Research Now <sup>&reg;</sup> {translatedText.disclaimer[1]} Research Now Group, Inc.
			</p>
		</div>
	</div>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js